import React from "react";
import Box from "@mui/material/Box";

const SectionFrame: React.FC<{ nav: React.ReactNode; children: React.ReactNode }> = ({ nav, children }) => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      minWidth: 0,
      minHeight: 0,
      overflow: "hidden",
    }}
  >
    {nav}
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 auto",
        minWidth: 0,
        minHeight: 0,
        overflow: "hidden",
        // Anchors a loading overlay to this column so a page that is still
        // fetching does not cover the queue nav beside it.
        position: "relative",
      }}
    >
      {children}
    </Box>
  </Box>
);

export default SectionFrame;
